<template>
  <b-row>
    <b-col class="img-col">
      <!-- <img class="img" src="@/assets/img/gestion/pics-14.png" alt="" /> -->
    </b-col>
    <b-col class="texto">
      <h5 class="bgi">
        {{ title }}
      </h5>

      <!-- <h5 class="title">
        {{ datos.nombreServicio }}
      </h5> -->

      <p class="left">
        {{ perfil }} <span class="parrafo">{{ datos.perfil }}</span>
      </p>
    </b-col>
    <b-col>
      <div class="button-gestion">
        <b-button
          :to="{
            name: 'bgi',
            params: { id: datos.idServicio, idUsuario: datos.idUsuario },
          }"
          class="btn-gestion"
          pill
          >Ingresar</b-button
        >
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      title: "Balance de Gestión Integral",
      perfil: "Perfil:",
      info: "Representante Ministerial",
    };
  },
  props: ["datos"],
  methods: {
    seleccionar(nombre) {
      this.$router.push({ name: nombre });
    },
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  background: #f5f5f5;
  margin-left: 20px;
  margin-right: 20px;
  height: 140px;
}
.texto {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bgi {
  color: #052333;
  font-weight: bold;
}
.img {
  width: 150px;
  margin-top: -10px;
}

.title {
  color: #052333;
}

.left {
  font-weight: 600;
  color: #052333;
}

.parrafo {
  font-weight: 400;
}

.col {
  display: flex;
  align-items: center;
}

.btn-gestion:hover {
  background: #3d185f;
}

.btn-gestion {
  background: #3d185f;
  text-align: center;
}

@media screen and (max-width: 827px) {
  .img {
    width: 110px;
  }

  h5 {
    font-size: 14px;
  }

  p {
    font-size: 12px;
  }

  .btn-gestion {
    font-size: 14px;
  }
}

@media screen and (max-width: 613px) {
  .img {
    width: 90px;
  }

  h5 {
    font-size: 12px;
  }

  p {
    font-size: 10px;
  }

  .btn-gestion {
    font-size: 10px;
  }
}

@media screen and (max-width: 406px) {
  .row {
    display: block;
    height: 300px;
  }

  .img-col {
    text-align: center;
  }

  .texto {
    text-align: center;
  }
}
</style>
